import { QueryKeys } from "../queryKeys.ts";
import { useStoreActions } from "../../../contexts.ts";
import { useQueries } from '@tanstack/react-query';
import { serviceModel } from "../../../models/index.ts";
import { isAfter } from 'date-fns';
import { useMemo } from 'react';
import { useFeatureFlags } from "../../useFeatureFlags.ts";
import { toDateStampObject } from "../../../models/time/translator.ts";
export const useServicesBillingDetails = _ref => {
  let {
    services,
    relationshipEffectiveDate
  } = _ref;
  const {
    START_BILLING_AT
  } = useFeatureFlags();
  const {
    api
  } = useStoreActions();
  const servicesWithStartBilling = useMemo(() => {
    if (!START_BILLING_AT) return [];
    return services.filter(service => {
      const startBillingAt = serviceModel.startBillingAt(service);
      return startBillingAt && relationshipEffectiveDate ? isAfter(startBillingAt, relationshipEffectiveDate) : false;
    });
  }, [services, START_BILLING_AT, relationshipEffectiveDate]);
  const billingPeriodsQueries = useQueries({
    queries: servicesWithStartBilling.map(service => {
      return {
        queryKey: [QueryKeys.ServiceBillingDetails, service],
        queryFn: () => {
          return api.relationship.serviceBillingDetails(serviceModel.toDTO(service), toDateStampObject(relationshipEffectiveDate));
        },
        select: data => ({
          serviceId: service.id,
          data
        }),
        cacheTime: 0,
        enabled: START_BILLING_AT && !!relationshipEffectiveDate
      };
    })
  });
  const servicesBillingDetails = useMemo(() => {
    return Object.fromEntries(billingPeriodsQueries.filter(_ref2 => {
      let {
        data
      } = _ref2;
      return !!data;
    }).map(_ref3 => {
      let {
        data
      } = _ref3;
      return [data === null || data === void 0 ? void 0 : data.serviceId, data === null || data === void 0 ? void 0 : data.data];
    }));
  }, [billingPeriodsQueries]);
  const loading = START_BILLING_AT && billingPeriodsQueries.some(query => query.isInitialLoading);
  const isFetching = START_BILLING_AT && billingPeriodsQueries.some(query => query.isFetching);
  return {
    servicesBillingDetails,
    loading,
    isFetching
  };
};